import { z } from 'zod'

export const leadIntakeSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Bitte geben Sie Ihren Vor- und Nachnamen ein.')
    .max(120, 'Höchstens 120 Zeichen.'),
  email: z.email('Bitte geben Sie eine gültige E-Mail-Adresse ein.'),
  phone: z
    .string()
    .trim()
    .min(1, 'Bitte geben Sie Ihre Telefonnummer ein.')
    .max(40, 'Höchstens 40 Zeichen.'),
  studio: z.string().min(1, 'Bitte wählen Sie ein Studio aus.'),
  origin: z.string().min(1, 'Bitte wählen Sie eine Herkunft aus.'),
  notes: z.string().trim().max(600, 'Höchstens 600 Zeichen.').optional(),
  consent: z
    .boolean()
    .refine((value) => value, { message: 'Bitte stimmen Sie der Datenverarbeitung zu.' }),
})

export type LeadIntakeInput = z.infer<typeof leadIntakeSchema>
